import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Alert, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useApiHook from "../../hooks/useApiHook";
import { useFolderRefresh, useRenameFolderModal } from "../../store/modal-context";
import ResponsiveDialog from "../_atoms/ResponsiveDialog";

const RenameFolderDialog = () => {
    const { isOpen, closeModal, payload } = useRenameFolderModal();
    const { refreshFolders } = useFolderRefresh();
    const { response, makeRequest, loading, error } = useApiHook();
    const [folderName, setFolderName] = useState("");
    const [submitRequested, setSubmitRequested] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        setFolderName(payload?.folderName || "");
        setSubmitRequested(false);
    }, [isOpen, payload?.folderName]);

    useEffect(() => {
        if (!isOpen || !submitRequested || !response || response.state !== 'success') {
            return;
        }

        refreshFolders();
        if (payload?.onSuccess) {
            payload.onSuccess(response.data);
        }

        setSubmitRequested(false);
        closeModal();
    }, [closeModal, isOpen, payload, refreshFolders, response, submitRequested]);

    const onConfirmHandler = () => {
        const trimmedFolderName = folderName.trim();
        if (!trimmedFolderName || !payload?.folderId) {
            return;
        }

        setSubmitRequested(true);
        makeRequest('/folder/rename', 'post', {
            folderId: payload.folderId,
            name: trimmedFolderName
        });
    };

    return (
        <ResponsiveDialog
            minWidth="unset"
            minHeight="unset"
            title={(
                <Stack direction="row" alignItems="center" spacing={1}>
                    <DriveFileRenameOutlineIcon fontSize="large" />
                    <Typography variant="h5">Rinomina cartella</Typography>
                </Stack>
            )}
            isOpen={isOpen}
            onClose={closeModal}
            actions={(
                <>
                    <Button
                        size="large"
                        variant="contained"
                        onClick={onConfirmHandler}
                        disabled={loading || !folderName.trim()}
                    >
                        Rinomina
                    </Button>
                    <Button size="large" onClick={closeModal}>
                        Annulla
                    </Button>
                </>
            )}
        >
            <Stack width="100%" spacing={2}>
                <Typography width="100%" textAlign="left" variant="body2" sx={{ opacity: 0.65 }}>
                    Inserisci il nuovo nome della cartella.
                </Typography>
                {error && (
                    <Alert severity="error">
                        Impossibile rinominare la cartella. Riprova.
                    </Alert>
                )}
                <TextField
                    autoFocus
                    fullWidth
                    label="Nome cartella"
                    value={folderName}
                    onChange={(event) => setFolderName(event.target.value)}
                />
            </Stack>
        </ResponsiveDialog>
    );
};

export default RenameFolderDialog;
